import React from 'react';
import { Button, ButtonProps } from '../Button/Button';

export default function PickerButton(props: ButtonProps) {
  return <Button size="sm" {...props} />;
}
